import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@components/primitives/Accordion';
import { Box, Typography } from '@mui/material';

interface DebugCardRendererProps {
  primitive: string;
  typeKey: string;
  data: unknown;
  defaultExpanded?: boolean;
}

export const DebugCardRenderer: React.FC<DebugCardRendererProps> = ({
  primitive,
  typeKey,
  data,
  defaultExpanded = false,
}) => (
  <Accordion defaultExpanded={defaultExpanded}>
    <AccordionSummary>
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          {primitive}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {typeKey}
        </Typography>
      </Box>
    </AccordionSummary>
    <AccordionDetails>
      <Box
        component="pre"
        sx={{
          m: 0,
          p: 2,
          bgcolor: '#1e1e1e',
          borderRadius: 1,
          fontSize: '13px',
          fontFamily: '"Fira Code", "Courier New", monospace',
          color: '#d4d4d4',
          lineHeight: 1.6,
          overflowX: 'auto',
        }}
      >
        {JSON.stringify(data, null, 2)}
      </Box>
    </AccordionDetails>
  </Accordion>
);
